class QuickbuyVariantSelects extends HTMLElement {
  constructor() {
    super();
    this.onOptionChange = this.onOptionChange.bind(this);
  }

  connectedCallback() {
    this.sectionId = this.dataset.section;
    this.url = this.dataset.url;
    this.formId = this.dataset.productFormId;
    this.form = document.getElementById(this.formId);

    this.addEventListener('change', this.onOptionChange);
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.onOptionChange);
  }

  async onOptionChange() {
    // get selected option value IDs and format
    const selectedOptions = this.selectedOptionValues;
    
    const params = `&option_values=${selectedOptions.join(',')}`;
    const fetchUrl = `${this.url}?section_id=card-product${params}`;

    const response = await fetch(fetchUrl, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    });

    if (!response.ok) return;

    const htmlText = await response.text();
    const doc = new DOMParser().parseFromString(htmlText, 'text/html');

    const newForm = doc.getElementById(this.formId);
    if (!newForm) return;

    // update variant id in form
    const newVariantId = newForm.querySelector('input[name="id"]').value;
    this.form.querySelector('input[name="id"]').value = newVariantId;
  

    // update price
    const newPrice = doc.querySelector('.price__container');
    const oldPrice = this.closest('.product-card-wrapper').querySelectorAll('.price__container');

    if (newPrice && oldPrice) {
      oldPrice.forEach((price) => {
        price.innerHTML = newPrice.innerHTML;
      });
    }

    // update add to cart button
    const addButtonUpdated = doc.querySelector(`[id^=ProductSubmitButton-`);
        
    this.toggleAddButton(
      addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
      window.variantStrings.soldOut
    );

    // update media
    const newMedia = doc.querySelector('.card__media');
    const oldMedia = this.closest('.product-card-wrapper').querySelector('.card__media');

    if (newMedia && oldMedia) {
      oldMedia.innerHTML = newMedia.innerHTML;
    }
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
      ({ dataset }) => dataset.optionValueId
    );
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(this.formId);

    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');

    const addButtonText = productForm.querySelector('[name="add"] .product-form__add-button-text');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }
}

customElements.define('quickbuy-variant-selects', QuickbuyVariantSelects);
